/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `climb_pro` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class ClimbProMesg : Mesg {
    public constructor() : super("ClimbPro", Profile.MesgNum.CLIMB_PRO)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp, in s. */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** position_lat, in semicircles. */
    public var positionLat: Int?
        get() = getFieldValue(POSITION_LAT_FIELD_NUM) as? Int
        set(value) = setFieldValue(POSITION_LAT_FIELD_NUM, value)

    /** position_long, in semicircles. */
    public var positionLong: Int?
        get() = getFieldValue(POSITION_LONG_FIELD_NUM) as? Int
        set(value) = setFieldValue(POSITION_LONG_FIELD_NUM, value)

    /** climb_pro_event. */
    public var climbProEvent: ClimbProEvent?
        get() = (getFieldValue(CLIMB_PRO_EVENT_FIELD_NUM) as? UByte)?.let { ClimbProEvent.fromValue(it) }
        set(value) = setFieldValue(CLIMB_PRO_EVENT_FIELD_NUM, value?.value)

    /** climb_number. */
    public var climbNumber: UShort?
        get() = getFieldValue(CLIMB_NUMBER_FIELD_NUM) as? UShort
        set(value) = setFieldValue(CLIMB_NUMBER_FIELD_NUM, value)

    /** climb_category. */
    public var climbCategory: UByte?
        get() = getFieldValue(CLIMB_CATEGORY_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CLIMB_CATEGORY_FIELD_NUM, value)

    /** current_dist, in m. */
    public var currentDist: Float?
        get() = getFieldValue(CURRENT_DIST_FIELD_NUM) as? Float
        set(value) = setFieldValue(CURRENT_DIST_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val POSITION_LAT_FIELD_NUM: UByte = 0u
        public const val POSITION_LONG_FIELD_NUM: UByte = 1u
        public const val CLIMB_PRO_EVENT_FIELD_NUM: UByte = 2u
        public const val CLIMB_NUMBER_FIELD_NUM: UByte = 3u
        public const val CLIMB_CATEGORY_FIELD_NUM: UByte = 4u
        public const val CURRENT_DIST_FIELD_NUM: UByte = 5u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "s", false)
            fields[0] = Field("PositionLat", 0u, BaseType.SINT32, 1.0, 0.0, "semicircles", false)
            fields[1] = Field("PositionLong", 1u, BaseType.SINT32, 1.0, 0.0, "semicircles", false)
            fields[2] = Field("ClimbProEvent", 2u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[3] = Field("ClimbNumber", 3u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[4] = Field("ClimbCategory", 4u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[5] = Field("CurrentDist", 5u, BaseType.FLOAT32, 1.0, 0.0, "m", false)
            return fields
        }
    }
}
